module.exports = __webpack_public_path__ + "media/Loops 90 Strings.b29e24a1.wav";